import {Space} from 'antd';
import styled from 'styled-components';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledBudgetRequestApprovalFlow = styled(Space)`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 24px;
  width: 100%;
`;

const StyledBudgetRequestApprovalFlowDivider = styled.div`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;

  .ant-btn {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    margin: auto;
    font-size: 10px;
    height: 18px;
    width: 18px;
  }
`;

const StyledBudgetRequestApprovalFlowReviewActions = styled.div`
  z-index: 2;
  bottom: 0;
  display: none;
  margin-left: auto;
  position: absolute;
  right: 0;
  transform: translateY(calc(100% + 6px));
  .ant-btn-icon {
    display: flex;
  }
`;

const StyledBudgetRequestApprovalFlowReview = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const StyledBudgetRequestApprovalFlowReviewContainer = styled(Space)`
  width: 100%;
  padding-bottom: ${props => props.last === 'true' ? '32px' : '0px'};
  &:hover {
    ${StyledBudgetRequestApprovalFlowReviewActions} {
      display: unset;
    }
  }
`;

const StyledBudgetRequestApprovalFlowDeleteModal = styled.div`
  h5 {
    ${typographyStyles.heading.h5}
  }
  p {
    ${typographyStyles.body.regular};
    color: ${props => props.theme.colors.neutral_7};
    max-width: 300px;
  }
`;

export {
  StyledBudgetRequestApprovalFlow,
  StyledBudgetRequestApprovalFlowDivider,
  StyledBudgetRequestApprovalFlowReview,
  StyledBudgetRequestApprovalFlowReviewActions,
  StyledBudgetRequestApprovalFlowReviewContainer,
  StyledBudgetRequestApprovalFlowDeleteModal,
}
